import { Mapper } from "../../../../base/utils/mapper";
import { VersionModel } from "../../../../domain/models/consult/version.model";
import { VersionEntity } from "../entities/version.entity";



export class VersionImplementationRepositoryMapper extends Mapper<VersionEntity, VersionModel> {
    mapFrom(param: VersionEntity): VersionModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: VersionModel): VersionEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}